import React from "react";
import { turncate } from "../../../utilities/functions";

function NoteCell(data) {
  return <p>{data?.notes}</p>;
}

export default NoteCell;
